var _path, _circle, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepositsGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 29V26.3333C10 26.3333 8.22549 25.8922 6.66667 24.3333C5.58377 23.2504 5.36197 22.0635 5.32747 21.4396C5.31456 21.2061 5.12648 21 4.89264 21V21C3.84737 21 3 20.1526 3 19.1074V16.013C3 15.0853 3.75201 14.3333 4.67967 14.3333V14.3333C5.34512 14.3333 5.94783 13.9405 6.21643 13.3316L7.59468 10.2076C7.75349 9.84764 7.88131 9.47477 7.97673 9.09307L8.16894 8.32423C8.57924 6.68304 10.4644 6.01025 11.3821 7.4314C11.7898 8.06269 12.143 8.81036 12.3333 9.66667H16H19.9981C24.0759 9.66667 27.4073 12.9232 27.5 17V17",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.3333,
    cy: 15.6673,
    r: 1.33333,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5264 5.66732C18.1001 3.73966 19.8858 2.33398 21.9998 2.33398C24.5771 2.33398 26.6664 4.42332 26.6664 7.00065C26.6664 7.3439 26.6294 7.6785 26.5591 8.00065",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29L19 25L23 29L29 23",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 22.7031L29.2712 22.7031L29.2712 26.4744",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositsGrowth);
export default __webpack_public_path__ + "static/media/depositsGrowth.1711abfbc1166561ddabb10c0ebeba9d.svg";
export { ForwardRef as ReactComponent };